/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import { PACKAGE_DATA } from '../../common/constants';
import { ErrorBoundary } from '../../common/ui/error-boundary';
import { ErrorBoundaryModal } from '../../common/ui/error-boundary-modal';
import { Experience } from '../../common/ui/experience-tracker';
import { withLinkCreateAnalyticsContext } from '../../common/utils/analytics';
import { fetchMessagesForLocale } from '../../common/utils/locale/fetch-messages-for-locale';
import i18nEN from '../../i18n/en';
import LinkCreate from './main';
var LinkCreateWithAnalyticsContext = withLinkCreateAnalyticsContext( /*#__PURE__*/memo(function (props) {
  return jsx(Experience, null, jsx(ErrorBoundary, {
    errorComponent: jsx(ErrorBoundaryModal, {
      active: props.active,
      onClose: props.onCancel
    })
  }, jsx(LinkCreate, props)));
}));
var ComposedLinkCreate = /*#__PURE__*/memo(function (props) {
  return jsx(AnalyticsContext, {
    data: PACKAGE_DATA
  }, jsx(IntlMessagesProvider, {
    defaultMessages: i18nEN,
    loaderFn: fetchMessagesForLocale
  }, jsx(LinkCreateWithAnalyticsContext, props)));
});
export default ComposedLinkCreate;